<template>
<!-- 要区分维修、非维修 -->
  <div class="inquiry-detail">
    <content-block title="平台询价信息">
      <el-descriptions :column="3">
        <el-descriptions-item label="指定供应商">
          {{ detailInfo.assignSupplierList && detailInfo.assignSupplierList.length > 0 ? `${ detailInfo.assignSupplierList.length}家` : '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="平台商家">{{ detailInfo.merchantMinNum ? `${detailInfo.merchantMinNum}家` : '--' }}</el-descriptions-item>
        <el-descriptions-item label="询价商家地区">
          <template v-if="detailInfo.merchantMinNum">
            <span v-if="!detailInfo.merchantAreaLimitType">不限地区</span>
            <el-tooltip v-else effect="dark" :content="detailInfo.assignAreaListStr" placement="top-start">
              <div class="long-text">{{ detailInfo.assignAreaListStr }}</div>
            </el-tooltip>
          </template>
          <template v-else>--</template>
        </el-descriptions-item>
      </el-descriptions>
    </content-block>
    <content-block title="基本信息">
      <el-descriptions :column="3">
        <el-descriptions-item label="询价单位">{{ detailInfo.inquirePriceParty || '--' }}</el-descriptions-item>
        <el-descriptions-item label="终端用户">{{ detailInfo.terminalCustomer || '--' }}</el-descriptions-item>
        <el-descriptions-item label="询价场地">{{ detailInfo.siteName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="业务类型">
          {{ detailInfo.businessType === 'MAINTAIN' ? '维修' : detailInfo.businessType === 'SPARE_PART' ? '备件' : '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="渠道要求" v-if="detailInfo.businessType === 'MAINTAIN'">{{ detailInfo.channelRequireDesc || '--' }}</el-descriptions-item>
        <!-- <el-descriptions-item label="兼容性要求" v-else>{{ detailInfo.compatibilityRequirementDesc || '--' }}</el-descriptions-item> -->
        <el-descriptions-item label="交付方式">{{ detailInfo.deliveryMethodDesc || '--' }}</el-descriptions-item>
        <el-descriptions-item label="期望交期">
          {{ formatDateCell(detailInfo.expectedDeliveryDate, detailInfo.businessType === 'MAINTAIN' ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD') }}
        </el-descriptions-item>
        <el-descriptions-item label="备用机" v-if="detailInfo.businessType === 'MAINTAIN'">{{ detailInfo.requireSpareMachineFlag ? '需要' : '不需要' }}</el-descriptions-item>
        <el-descriptions-item label="申请人">{{ detailInfo.createUserName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="申请人电话">{{ detailInfo.createUserPhone || '--' }}</el-descriptions-item>
        <!-- <el-descriptions-item label="创建人">{{ '--' }}</el-descriptions-item>
        <el-descriptions-item label="创建人电话">{{ '--' }}</el-descriptions-item> -->
        <el-descriptions-item label="需求单号">{{ detailInfo.requirementCode || '--' }}</el-descriptions-item>
        <el-descriptions-item label="交付地址" :span="3">
          <template>
            <el-tooltip effect="dark" :content="`${detailInfo.deliveryProvinceName}${detailInfo.deliveryCityName}${detailInfo.deliveryAreaName}${detailInfo.deliveryDetailAddress}` || ''" placement="top-start">
              <div class="long-text">{{ `${detailInfo.deliveryProvinceName}${detailInfo.deliveryCityName}${detailInfo.deliveryAreaName}${detailInfo.deliveryDetailAddress}` || '--' }}</div>
            </el-tooltip>
          </template>
        </el-descriptions-item>
        <el-descriptions-item label="询单备注" :span="3">{{ detailInfo.inquirePriceRemark || '--' }}</el-descriptions-item>
        <el-descriptions-item label="附件" :span="3">
          <template v-if="detailInfo.inquirePriceAnnexList && detailInfo.inquirePriceAnnexList.length">
            <el-link v-for="i in detailInfo.inquirePriceAnnexList" :href="encodeURI(i.url)" :key="i.id" target="_blank" style="margin-right: 0.5em;" type="primary">
              {{ i.url.split('/').pop() }}
            </el-link>
          </template>
        </el-descriptions-item>
      </el-descriptions>
    </content-block>
    <content-block v-if="detailInfo.businessType === 'MAINTAIN'" title="报修信息">
      <el-descriptions :column="3">
        <el-descriptions-item label="终端用户">{{ detailInfo.terminalCustomer || '--' }}</el-descriptions-item>
        <el-descriptions-item label="业务单元">{{ detailInfo.deviceInfo.businessDepartment || '--' }}</el-descriptions-item>
        <el-descriptions-item label="报修场地">{{ detailInfo.siteName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="设备名称">{{ detailInfo.deviceInfo.deviceName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="设备型号">{{ detailInfo.deviceInfo.deviceModel || '--' }}</el-descriptions-item>
        <el-descriptions-item label="设备序列号">{{ detailInfo.deviceInfo.deviceSerialNumber || '--' }}</el-descriptions-item>
        <el-descriptions-item label="设备分类">
          <template>
            <el-tooltip effect="dark" :content="detailInfo.deviceInfo.standardCategory || ''" placement="top-start">
              <div class="long-text">{{ detailInfo.deviceInfo.standardCategory || '--' }}</div>
            </el-tooltip>
          </template>
        </el-descriptions-item>
        <el-descriptions-item label="行业分类">{{ detailInfo.deviceInfo.industryCategory || '--' }}</el-descriptions-item>
        <el-descriptions-item label="设备数量">{{ (detailInfo.deviceInfo.quantity + detailInfo.deviceInfo.unitName) || '--' }}</el-descriptions-item>
        <el-descriptions-item label="故障类型">{{ detailInfo.deviceInfo.faultTypeName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="故障编码" :span="2">{{ detailInfo.deviceInfo.faultCode || '--' }}</el-descriptions-item>
        <el-descriptions-item label="故障描述" :span="3">{{ detailInfo.deviceInfo.faultDescription || '--' }}</el-descriptions-item>
        <el-descriptions-item label="故障图片" :span="3">
          <template v-if="detailInfo.deviceInfo.faultImageList && detailInfo.deviceInfo.faultImageList.length">
            <el-image
              :preview-src-list="detailInfo.deviceInfo.previewFaultImageList"
              v-for="(img, index) in detailInfo.deviceInfo.faultImageList" referrer-policy='unsafe-url'
              :z-Index='index' style="width:40px;height:40px;vertical-align: middle;margin-right:10px"
              :src="`${img.url}?imageView2/2/w/40/h/40`" :key='img.url'></el-image>
          </template>
        </el-descriptions-item>
      </el-descriptions>
      <template v-if="detailInfo.businessType === 'MAINTAIN' && sparePartList.length">
        <div>备件清单</div>
        <TableWithPagination :tableData="sparePartList" :columnList="columnList" row-key="index" size="mini" :editConfig="{ trigger: 'munal', mode: 'cell' }" />
      </template>
    </content-block>
    <template v-if="detailInfo.businessType === 'SPARE_PART'">
      <content-block title="备件信息">
        <el-button @click="handleExport" type="primary" size="mini">导出</el-button>
        <TableWithPagination :tableData="sparePartList" :columnList="columnList" row-key="index" size="mini" :editConfig="{ trigger: 'munal', mode: 'cell' }" :footerData="footerData" :showFooter="true" />
      </content-block>
    </template>
    <content-block title="收货信息">
      <el-descriptions :column="3">
        <el-descriptions-item label="联系人">{{ receiptForm.name || '--' }}</el-descriptions-item>
        <el-descriptions-item label="收货电话">{{ receiptForm.phone || '--' }}</el-descriptions-item>
        <el-descriptions-item label="邮编">{{ receiptForm.postcode || '--' }}</el-descriptions-item>
        <el-descriptions-item label="收货地址" :span="3">{{ receiptForm.receiptAddr || '--' }}</el-descriptions-item>
      </el-descriptions>
    </content-block>
  </div>
</template>
<script>
import { dateFormat } from '@/utils/dateFormat';
import { getDetailByInquiry, getSparePartPageList, exportSparePart } from '@/api/RFQ';
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
export default {
  mixins: [TablePaginationMixin],
  components: {
    TableWithPagination,
  },
  computed: {
    columnList () {
      let currentLists = [];
      let baseLists = [
        {
          tooltip: true,
          label: '备件图片',
          field: 'imageList',
          minWidth: 150,
          render: (h, { row }) => {
            let imageList = row.imageList || [];
            if (imageList && !!imageList.length) {
              let previewLists = (imageList || []).map(item => item.url.endsWith('.heic') ? `${item.url}?imageView2/2/w/800/h/800` : item.url) || [];
              return imageList.map((img, index) => (
                <el-image
                  referrer-policy="unsafe-url"
                  preview-src-list={previewLists}
                  z-Index={index}
                  src={`${img.url}?imageView2/2/w/40/h/40`}
                  style={'width:40px;height:40px;vertical-align: middle;margin-right:10px'}
                ></el-image>
              ));
            }
          },
        },
        {
          tooltip: true,
          label: '备件码',
          prop: 'code',
          minWidth: '140px',
        },
        {
          tooltip: true,
          label: '备件名称',
          prop: 'name',
          minWidth: '140px',
        },
        {
          tooltip: true,
          label: '备件型号',
          prop: 'model',
          minWidth: '140px',
        },
      ];
      let otherLists = [
        {
          tooltip: true,
          label: '备件规格',
          prop: 'spec',
          minWidth: '140px',
        },
        {
          tooltip: true,
          label: '数量',
          prop: 'quantity',
          minWidth: '140px',
        },
        {
          tooltip: true,
          label: '单位',
          minWidth: '140px',
          prop: 'unitName',
        },
        {
          tooltip: true,
          label: '兼容性',
          minWidth: '140px',
          prop: 'compatibilityRequirementDesc',
        },
        {
          tooltip: true,
          label: '关联设备',
          minWidth: '140px',
          prop: 'device',
        },
        {
          tooltip: true,
          label: '备注',
          minWidth: '100px',
          prop: 'remark',
        },
      ];
      let otherLists2 = [
        {
          tooltip: true,
          label: '数量（单位）',
          prop: 'quantity',
          minWidth: '140px',
          render: (h, { row }) => {
            let result = [];
            result.push(`${row.quantity}${row.unitName || ''}`);
            return h('span', result);
          },
        },
      ];
      if (this.detailInfo.businessType === 'MAINTAIN') { // '维修'
        currentLists = [...baseLists, ...otherLists2];
      }
      if (this.detailInfo.businessType === 'SPARE_PART') { // '备件'
        currentLists = [...baseLists, ...otherLists];
      }
      return currentLists;
    },
    footerData () {
      if (this.sparePartList.length) {
        let total = 0;
        for (let i = 0; i < this.sparePartList.length; i++) {
          const info = this.sparePartList[i];
          total += +info.quantity;
        }
        return [
          {
            checkTitle: '合计',
            quantity: total,
          },
        ];
      }
      return [];
    },
  },
  props: {
    inquiryId: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      id: '',
      sparePartList: [],
      detailInfo: {
        deviceInfo: {},
      },
      receiptForm: {},
    };
  },
  methods: {
    formatDateCell (v, type) {
      return v ? dateFormat(v * 1).format(type) : '--';
    },
    download ({ data, type, fileTitle }) {
      let blob = new Blob([data], { type });
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = fileTitle;
      document.querySelectorAll('body')[0].appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    handleExport () {
      const fileTitle = `询单备件_${dateFormat(new Date()).format('YYYY-MM-DD')}`;
      exportSparePart({ inquirePriceId: this.id }).then(({ data }) => {
        this.download({
          data: data,
          fileTitle,
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
      });
    },
    async querySparePartPageList () {
      const { body } = await getSparePartPageList({
        inquirePriceId: this.id,
        pageFlag: false,
        pageNum: 1,
        pageSize: 99999,
        orderBy: [
          {
            orderByProperty: 'createTime',
            orderByType: 'DESC',
          },
        ],
      });
      this.sparePartList = body.list || [];
    },
    async queryDetailByInquiry () {
      const { body } = await getDetailByInquiry({ id: this.id });
      this.detailInfo = body;
      this.detailInfo.assignAreaListStr = (body.assignAreaList || []).map(area => `${area.cityName ? area.provinceName + '/' + area.cityName : area.provinceName}`).join('、');
      this.detailInfo.deviceInfo = body.deviceList?.length ? body.deviceList[0] : {};
      if (this.detailInfo.deviceInfo.faultImageList?.length) {
        this.detailInfo.deviceInfo.previewFaultImageList = this.detailInfo.deviceInfo.faultImageList.map(img => img.url);
      }
      this.receiptForm = {
        postcode: body.deliveryPostcode || '',
        name: body.deliveryUserName || '',
        phone: body.deliveryPhone || '',
        receiptAddr: `${body.deliveryProvinceName || ''}${body.deliveryCityName || ''}${body.deliveryAreaName || ''}${body.deliveryDetailAddress || ''}`,
      };
    },
  },
  watch: {
    id (v) {
      if (v) {
        this.querySparePartPageList();
        this.queryDetailByInquiry();
      }
    },
  },
  mounted () {
    this.id = this.inquiryId;
  },
};
</script>
<style lang="scss" scoped>
.inquiry-detail {
  .long-text {
    max-width: 350px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
